export default __webpack_public_path__ + "static/media/Rectangle38.41a9359f.png";